// extracted by mini-css-extract-plugin
export var parcelRow = "_wc-0";